import React from "react";

//image
import DeleteIcon from '/public/AdminIcons/dlt.png';
import defaultPic from '/public/AdminIcons/default.svg'

//style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

//component
import Loader from "../../Loader/Loader";
import cp from '../../../components/commonStyle.css'


class CommonImageDisplay extends React.Component {

    render() {
        const { loader, loading, image, deleteImage, isDefaultPic, isDelete, imageBanner } = this.props;
        return (
            <Loader show={loader} type={"page"}>
                <div className={cx(cp.imageUploadDropzoneSection, !imageBanner && cp.imageUploadDropzoneSectionOutline)}>
                    {
                        !loading && <div
                            style={{ backgroundImage: `url(${!isDefaultPic ? image : defaultPic})` }}
                            className={cx(cp.commonDropZoneImgContainer, isDefaultPic && cp.commonDropZoneDefaultImg)}
                        />
                    }
                </div>
                {
                    !loading && !isDefaultPic && isDelete && <a href="javascript:void(0);" onClick={() => deleteImage()} className={cx(cp.trashIconNew, 'trashIconRTL')}>
                        <img src={DeleteIcon} alt='Delete' />
                    </a>
                }
            </Loader>
        )
    }
};

export default withStyles(cp)(CommonImageDisplay);